import React from 'react';
import Vimeo from '@u-wave/react-vimeo'
import { Online } from "react-detect-offline"
// import { StructuredData } from '.'
import { FIREBASE_STORAGE_PATH } from '../../utils'

const MILAN_LOGO = `${FIREBASE_STORAGE_PATH}general%2Fseo%2FMilan-Logo-Blue.webp?alt=media&token=eacafc73-400d-4131-bde8-3b469aca0229`

export function WhatCustomersSay() {
  return (
    <section className="py-5 milan-video">
      <div className="container">
        <h2 className="subheadlg milan-text-primary text-center pb-0">Hear What Our Customers Have To Say!</h2>
        <div className="row">
          <div className="col-lg-10 mx-auto  text-center embed-responsive embed-responsive-21by9">
            {/* <iframe 
            src="https://player.vimeo.com/video/326630810?title=0&byline=0&portrait=0?title=0&byline=0&portrait=0" 
            style={{height: 'calc(50vw)', maxHeight: '450px'}} 
            className="video embed-responsive-item w-100" frameBorder="0" 
            webkitallowfullscreen="true" mozallowfullscreen="true" allowFullScreen ></iframe> */}
            <Online><Vimeo video="760004973" showTitle={false} showByline={false} /></Online>
          </div>
        </div>
      </div>
      {/* <StructuredData>
        {
          {
            "@context": "https://schema.org",
            "@type": "VideoObject",
            "name": "Go Hair-Free with Milan Laser",
            "description": "Milan Laser is the nations expert in Laser Hair Removal. Get smooth, hair free skin with permanent results. Milan Laser has more than 220 locations in 28 states & the only company offering The Unlimited Package with Lifetime Guarantee.",
            "thumbnailUrl": "https://i.vimeocdn.com/video/770703526-204ceff9d607f6a0b20fde30f64b1fcf290ddb7a96817d9335227f0d5943edbd-d_295x166",
            "uploadDate": "2019-02-25T10:33:00-06:00",
            "duration": "PT0M40S",
            "publisher": {
              "@type": "Organization",
              "name": "Milan Laser Hair Removal",
              "logo": {
                "@type": "ImageObject",
                "url": `${MILAN_LOGO}`,
                "width": 190,
                "height": 80
              }
            },
            "contentUrl": "https://player.vimeo.com/video/319491411",
            "embedUrl": "https://vimeo.com/319491411",
            "interactionCount": "30"
          }
        }
      </StructuredData> */}
    </section>
  )
}
export default WhatCustomersSay;